import api from './authService';
import {
  TimesheetCustomCategory,
  TimesheetCustomCategoryPayload,
} from '../types';

export const timesheetCategoriesService = {
  async list(): Promise<TimesheetCustomCategory[]> {
    const response = await api.get('/timesheet/custom-categories');
    return response.data.categories || [];
  },

  async mine(userId?: number): Promise<TimesheetCustomCategory[]> {
    const params: Record<string, number> = {};
    if (userId) params.user_id = userId;
    const response = await api.get('/timesheet/custom-categories/mine', { params });
    return response.data.categories || [];
  },

  async create(payload: TimesheetCustomCategoryPayload): Promise<TimesheetCustomCategory> {
    const response = await api.post('/timesheet/custom-categories', payload);
    return response.data.category;
  },

  async update(
    id: number,
    payload: TimesheetCustomCategoryPayload
  ): Promise<{ category: TimesheetCustomCategory; warnings?: string[] }> {
    const response = await api.put(`/timesheet/custom-categories/${id}`, payload);
    return response.data;
  },

  async remove(id: number): Promise<void> {
    await api.delete(`/timesheet/custom-categories/${id}`);
  },
};

export default timesheetCategoriesService;
